export default "__VITE_ASSET__Dy4Zdiyh__"